<section class="breadcrumb">
    <div class="container">
        <div class="row no-gutter">
            <div class="col-md-12 breadcrumb-wrap">
                <p><a (click)="onHome()">Home</a> <img src="./../../../assets/images/rightArrow.svg"></p>
                <h2>{{title}} {{additionalMsg ? '-': ''}} {{additionalMsg}}</h2>
            </div>
        </div>
    </div>
</section>